import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export enum THEME {
  LIGHT = 'light',
  DARK = 'dark',
}
export interface ILayout {
  collapsed: boolean;
  theme: THEME;
  key: {
    key: string;
    label: string;
  };
}

const initialState: ILayout = {
  collapsed: false,
  theme: THEME.LIGHT,
  key: {
    key: '1',
    label: 'dashboard',
  },
};

export const layoutSlice: Slice<ILayout> = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setCollapsed: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload;
    },
    setTheme: (state, action: PayloadAction<THEME>) => {
      state.theme = action.payload;
    },
    setSelectedMenuKey: (
      state,
      action: PayloadAction<{ key: string; label: string }>
    ) => {
      state.key = action.payload;
    },
  },
});

export const { setCollapsed, setTheme, setSelectedMenuKey } =
  layoutSlice.actions;

export const selectLayout = (state: RootState) => state.layout;
